// removed by extract-text-webpack-plugin
module.exports = {"row":"OptInItem-row-7d8fdf4a","col":"OptInItem-col-69b3736f","button":"OptInItem-button-4ec527ab","bannerAd":"OptInItem-bannerAd-c15b160b","rail":"OptInItem-rail-733aac49","optInContainer":"OptInItem-optInContainer-bb05b16b","top":"OptInItem-top-1603ec87","oemLogo":"OptInItem-oemLogo-2592a0bd","logo":"OptInItem-logo-47813372","bottom":"OptInItem-bottom-6cae0c1a","description":"OptInItem-description-76e4a55f","radioButtons":"OptInItem-radioButtons-575f5022","yes":"OptInItem-yes-82fde40f","no":"OptInItem-no-ce2b7508","radioBoxError":"OptInItem-radioBoxError-61e7b070","error":"OptInItem-error-6cf09099"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OptIn/OptInItem/OptInItem.scss
// module id = 875
// module chunks = 0